module.exports = __webpack_public_path__ + "img/search-list.7c33a0c9.svg";